//Popups designed to be used with bootstrap.  This is only suitable for showing one popup at a time.
//
//
//methods:
//  open(options) - opens a popup.  There is no need to close it, it automatically closes after a button callback
//                  is completed.
//
//
//
// options: a json object
// {
//      title: "My popup"
//      body: "The popup body html"
//      buttons: [
//          {
//              text: "Ok",
//              isPrimary: true/false.  Applies Bootstrap btn-primary class, default is false
//              callback: function(){} : function to be called when button is clicked.  This is optional
//                                       and is normally omitted on "Cancel" buttons.
//          }
//      ]
// }

;adc.popup = function() {
    var

    //our popup object
    $popup = null, 

    //our options passed to the open method
    _options = null,

    //
    //open the popup
    //
    open = function(opt) {
        _options = opt;

        //create the popup html
        var s = "<div class='modal fade' tabindex='-1' role='dialog'>";
        s += "<div class='modal-dialog' role='document'>";
        s += "<div class='modal-content'>";
        s += "<div class='modal-header'>";
        s += "<button type='button' class='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button>";
        s += "<h4 class='modal-title'>" + _options.title + "</h4>";
        s += "</div>";
        s += "<div class='modal-body'>";
        s += "<p>" + _options.body + "</p>";
        s += "</div>";
        s += "<div class='modal-footer'>";

        if (_options.buttons) {
            for (var i=0; i<_options.buttons.length; i++) {
                var b = _options.buttons[i];

                s += "<button type='button' ";
                s += "class='btn btn-" + (b.isPrimary ? "primary" : "default") + "'";
                s += "data-dismiss='modal' data-button-index='" + i + "'>" + b.text + "</button>";
            }
        }
        s += "</div>";
        s += "</div>";
        s += "</div>";
        s += "</div>";

        //turn it into a jquery elem and add to the body
        $popup = $(s);
        $('body').append($popup);
        $popup.modal('show');

        //now bind the function handlers
        if (_options.buttons) {
            var $btns = $popup.on('click', '.modal-footer button', function() {
                var index = $(this).attr('data-button-index');

                //get the button
                var b = _options.buttons[index];

                //call the cb
                if (b.callback) {
                    b.callback();
                }
            });
        }

        //hookup hidden event to remove the popup
        $popup.on('hidden.bs.modal', function() {
            $popup.remove();
        });
    };



    //return methods
    return {
        open: open
    };
}();